import { shallowEqual, useSelector } from 'react-redux';
import { AppState } from '@app/store/reducers';

export const useIsLoggedInSelector = (): boolean => useSelector<AppState, boolean>(
  (state) => state.user.isLoggedIn,
  shallowEqual,
);
